export const UNIT_TYPES = [{
  key: 'Studio',
  name: 'Studio'
}, {
  key: 'OneBedroom',
  name: 'One bedroom'
}, {
  key: 'TwoBedrooms',
  name: 'Two bedrooms'
}, {
  key: 'ThreeBedrooms',
  name: 'Three bedrooms'
}
// { NOTE: Currently Disabled
//   key: 'Penthouse',
//   name: 'Penthouse',
// },
];
export const UNIT_STATUSES_NAMED = {
  Enrolled: 'Enrolled',
  Vacant: 'Vacant',
  ToBeVacantSoon: 'ToBeVacantSoon'
};